import type { RequestHandler } from 'msw'
import { type ReactElement, useEffect, useState } from 'react'

export type MswProps = {
  children: ReactElement
  mswHandlers: RequestHandler[]
}

export function Msw(props: MswProps) {
  const { children, mswHandlers } = props
  const [ready, setReady] = useState(false)

  useEffect(() => {
    if (mswHandlers.length === 0) return

    async function initMsw() {
      const { http, passthrough } = await import('msw')
      const { setupWorker } = await import('msw/browser')

      const defaultHandlers = [http.all('@fs/*', passthrough)]

      const msw = window.__tidal_stories_msw ?? setupWorker()
      msw.use(...defaultHandlers, ...mswHandlers)

      if (!window.__tidal_stories_msw) {
        window.__tidal_stories_msw = msw
      }

      await msw.start({
        serviceWorker: {
          url: `${(import.meta as any).env.BASE_URL}mockServiceWorker.js`,
        },
      })

      setReady(true)
    }

    initMsw()

    return () => {
      if (window.__tidal_stories_msw) {
        window.__tidal_stories_msw.resetHandlers()
        window.__tidal_stories_msw.stop()
        // window.__tidal_stories_msw.use(...defaultHandlers)
      }
    }
  }, [mswHandlers])

  if (mswHandlers.length === 0) return children
  if (!ready) return null
  return children
}
